import styled from 'styled-components';
// import { ITheme } from '../../atoms/check';
import { useEffect, useState, useContext } from 'react';
import { CheckRadioGroupInfo, GroupedCheckRadioGroupInfo } from '../../../types';
import { ICustomTheme, ThemeContextV2 } from '../../../themeV2';
import { Radio, RadioGroup, Box } from '@chakra-ui/react';

interface IProps {
  id?: string;
  items: CheckRadioGroupInfo[];
  groupedItems?: GroupedCheckRadioGroupInfo[];
  disabled?: boolean;
  radioListValue?: string;
  onChange: (value: string) => void;
}

export const CheckRadioGroupListV2 = ({
  id,
  items,
  groupedItems,
  disabled = false,
  radioListValue,
  onChange
}: IProps) => {
  const defaultTheme = useContext(ThemeContextV2);

  const [listItems, setListItems] = useState<CheckRadioGroupInfo[] | GroupedCheckRadioGroupInfo[]>([]);
  let radioValue = '';
  if (groupedItems) {
    radioValue = radioListValue || groupedItems[0]?.options[0]?.value;
  } else if (items) {
    radioValue = radioListValue || items?.[0].value;
  }

  useEffect(() => {
    groupedItems ? setListItems(groupedItems) : setListItems(items);
  }, [items, groupedItems]);

  const grouped = listItems as GroupedCheckRadioGroupInfo[];
  const nonGroupedItems = listItems as CheckRadioGroupInfo[];
  if (groupedItems) {
    return (
      <div id={id || 'CheckRadioList'}>
        {grouped.map((group, index) => (
          <Container key={`check-radio-group-list-container-${index}`} data-selector={`radio-group-${id || index}`}>
            <GroupHeader theme={defaultTheme} key={`check-radio-group-list-header-container-${index}`}>
              {group.label}
            </GroupHeader>
            <RadioGroup
              name={`${id}-${index}`}
              id={`${id}-${index}`}
              data-selector="radio-group"
              onChange={onChange}
              isDisabled={disabled}
              value={radioValue}
            >
              {group.options.map(checkRadioGroup => (
                <Box key={checkRadioGroup.value}>
                  <Radio value={checkRadioGroup.value} data-selector={checkRadioGroup.label}>
                    {checkRadioGroup.label}
                  </Radio>
                </Box>
              ))}
            </RadioGroup>
          </Container>
        ))}
      </div>
    );
  }
  return (
    <RadioGroup
      name={id}
      id={id}
      data-selector={`radio-group${id ? `-${id}` : ''}`}
      onChange={onChange}
      isDisabled={disabled}
      value={radioValue}
    >
      {nonGroupedItems.map((checkRadioGroup, _index) => {
        return (
          <Radio
            key={checkRadioGroup.value}
            value={checkRadioGroup.value}
            data-selector={checkRadioGroup.label}
            aria-checked={checkRadioGroup.value === radioListValue}
            variant="ghost"
            mb="0.5"
          >
            {checkRadioGroup.label}
          </Radio>
        );
      })}
    </RadioGroup>
  );
};

const Container = styled.div``;

const GroupHeader = styled.p<{ theme: ICustomTheme }>`
  color: ${({ theme }) => theme.colors.blue900};
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
`;
